import { ELEMENT_MAIN, SIZE } from '../settings/constants';
import { TweenMax, Power1 } from 'gsap';
import { getSizeData } from './ResizeData';
import { TEXT_SETTINGS } from '../settings/texts';

// --------------------------------------------------------------
// Scroll value
// --------------------------------------------------------------

const mainELement = document.getElementById(ELEMENT_MAIN);

export const getCurrentScrollValue = (): number => {
  if (mainELement) {
    const { top } = mainELement.getBoundingClientRect();
    const { window, stage } = getSizeData();
    const scrollY = top * -1;
    const rawScrollProgress = scrollY / (SIZE.SCROLL * stage.scale - window.height);
    return Math.min(1, Math.max(0, rawScrollProgress));
  }
  return 0;
};

// --------------------------------------------------------------
// Top
// --------------------------------------------------------------

export const scrollToTop = (): void => {
  const scrollY = document.getElementById(ELEMENT_MAIN)?.getBoundingClientRect().top;

  if (scrollY && window.scrollY !== scrollY) {
    window.scrollTo({
      top: window.scrollY + scrollY,
      left: 0,
      behavior: 'smooth',
    });
  }
};

// --------------------------------------------------------------
// Navigation
// --------------------------------------------------------------

const NAV_GOAL_OFFSET = 0.01;

export const continueScroll = (): void => {
  navigationScroll(getNextScrollGoal());
};

export const prevScroll = (): void => {
  navigationScroll(getPrevScrollGoal());
};

const getNextScrollGoal = (): number => {
  let goal = 1;
  const currentScroll = getCurrentScrollValue();
  for (let i = 0; i < TEXT_SETTINGS.length; i++) {
    const text = TEXT_SETTINGS[i];
    if (text.continue > currentScroll) {
      goal = text.continue + NAV_GOAL_OFFSET;
      break;
    }
  }
  return goal;
};

const getPrevScrollGoal = (): number => {
  let goal = 0;
  const currentScroll = getCurrentScrollValue() - 2 * NAV_GOAL_OFFSET;
  for (let i = TEXT_SETTINGS.length - 1; i >= 0; i--) {
    const text = TEXT_SETTINGS[i];
    if (text.continue < currentScroll) {
      goal = text.continue + NAV_GOAL_OFFSET;
      break;
    }
  }
  return goal;
};

const navigationScroll = (value: number): void => {
  if (mainELement) {
    const { top, height } = mainELement.getBoundingClientRect();
    const sizeData = getSizeData();
    const headerSize = window.scrollY + top;
    const scrollGoal = headerSize + (height - sizeData.window.height) * value;
    const scrollHeight = Math.abs(window.scrollY - scrollGoal);
    const scrollTime = scrollHeight > 2000 ? 8 : scrollHeight / 1000;
    TweenMax.killTweensOf(window);
    TweenMax.to(window, Math.max(0.4, scrollTime), { scrollTo: scrollGoal, ease: Power1.easeOut });
  }
};
